import classnames from 'classnames'
import { useTranslation } from 'next-i18next'

import LAYOUT_TYPES from '@src/quince-site-common/src/constants/layoutTypes'

import { RichText, RichTextProps } from '../../molecules'

import Arrow from './icons/arrow.inline.svg'
import Dollar from './icons/dollarIcon.inline.svg'
import LargeArrow from './icons/largeArrow.inline.svg'
import Plus from './icons/plus.inline.svg'
import styles from './supplyChain.module.scss'

export interface SupplyChainProps {
  supplyChainRichTitle: RichTextProps
  traditionalTitle?: string
  traditionalChainTitles?: string[]
  quinceChainTitles?: string[]
  quinceTitle?: string
  layoutType: LAYOUT_TYPES
  onClick?: () => void
  className?: string
}

const renderDollarLogoWithName = (name: string, dollarsNeeded = 1) => (
  <div className={classnames(styles.chianItemContent)}>
    {dollarsNeeded > 1 ? (
      <div className={classnames(styles.dollarIconsWrapper)}>
        {Array(dollarsNeeded).fill(<Dollar className={styles.dollarIcon} />)}
      </div>
    ) : (
      <Dollar className={styles.dollarIcon} />
    )}
    <p className={styles.chianItemText}>{name}</p>
  </div>
)

const ChainItem = ({
  title,
  index = 0,
  listLength = 1,
  isLongArrow = false,
}: {
  title: string
  index?: number
  listLength?: number
  isLongArrow?: boolean
}) => {
  const isLastItem = index === listLength - 1
  const is2ndLastItem = index === listLength - 2
  const dollarsNeeded = isLastItem ? listLength - 1 : 1

  return (
    <div className={styles.chianItem}>
      {renderDollarLogoWithName(title, dollarsNeeded)}
      {isLongArrow && <LargeArrow className={classnames(styles.longArrow)} />}
      {is2ndLastItem ? (
        <Arrow className={styles.postFixIcon} />
      ) : (
        !isLastItem && <Plus className={styles.postFixIcon} />
      )}
    </div>
  )
}

export const SupplyChain = (props: SupplyChainProps) => {
  const { t } = useTranslation('common')
  const {
    traditionalChainTitles = [
      t('factory'),
      t('sourcing_agents'),
      t('tariffs'),
      t('warehouse'),
      t('brand'),
      t('store'),
      t('you'),
    ],
    traditionalTitle = t('traditional_supply_chain'),
    quinceChainTitles = [t('factory'), t('you')],
    quinceTitle = t('quince_supply_chain'),
    layoutType = LAYOUT_TYPES.DEFAULT,
    className = '',
  } = props
  const wrapClasses = classnames(styles.supplyChainWrap, styles[`supplyChainWrap__${layoutType}`], className)

  // eslint-disable-next-line i18next/no-literal-string
  const subHeadingClassName = 'font-case--upper subtitle1_grosa'
  return (
    <div className={wrapClasses}>
      <RichText {...props.supplyChainRichTitle} />
      <div className={styles.contentWrapper}>
        <h3 className={classnames(subHeadingClassName, styles.subtitle1)}>{traditionalTitle}</h3>
        <div className={styles.scrollBox}>
          <div className={styles.traditionalChainWrapper}>
            {traditionalChainTitles.map((title: string, index) => (
              <ChainItem key={title} index={index} listLength={traditionalChainTitles.length} title={title} />
            ))}
          </div>
        </div>

        <h3 className={classnames(subHeadingClassName, styles.subtitle2)}>{quinceTitle}</h3>
        <div className={styles.scrollBox}>
          <div className={classnames(styles.quinceChain)}>
            {quinceChainTitles.map((title: string, index) => {
              return <ChainItem key={title} title={title} isLongArrow={index < quinceChainTitles.length - 1} />
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SupplyChain
